var map = {
	"./1.png": "e77a",
	"./2.png": "ddec",
	"./3-bottom.png": "76c1",
	"./3-top-right.png": "208b",
	"./3-top.png": "d3ff",
	"./3.png": "c2db",
	"./hand.png": "7ae0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e9a";